import { Middleware } from "redux";
import { ADD_ALERT, AddAlertAction, AlertActionTypes } from "./types";
import { RootState } from "../../store";

// type guard to check if action is an alert action
const isAlertAction = (action: any): action is AlertActionTypes => {
	return action.type === ADD_ALERT;
};

const alertMiddleware: Middleware<{}, any> = (store) => (next) => (action) => {
	if (isAlertAction(action)) {
		const alertAction = action as AddAlertAction;
		const state = store.getState();

		const isDuplicate = (state as RootState).alerts.alerts.some(
			(alert) => alert.message === alertAction.payload.message
		);

		if (isDuplicate) return; // block duplicate actions
	}

	return next(action); // pass non-duplicate actions through
};

export default alertMiddleware;
